"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var RxPlayerController_1 = __importDefault(require("./RxPlayerController"));

var components_1 = require("../../components");

var PlayerError_1 = __importDefault(require("../../utils/PlayerError"));

var INITIAL_BITRATE = 2000000;

var RxPlayerBackend =
/** @class */
function (_super) {
  __extends(RxPlayerBackend, _super);

  function RxPlayerBackend() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.videoElement = null;
    _this.controller = null;
    return _this;
  }

  RxPlayerBackend.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var RxPlayer, _a, DASH, DIRECTFILE, rxPlayer;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (this.videoElement === null) {
              throw new PlayerError_1["default"]('VideoElement cannot be null in componentDidMount', {
                fatal: true
              });
            }

            return [4
            /*yield*/
            , Promise.resolve().then(function () {
              return __importStar(require('rx-player/minimal'));
            })];

          case 1:
            RxPlayer = _b.sent()["default"];
            return [4
            /*yield*/
            , Promise.resolve().then(function () {
              return __importStar(require('rx-player/features'));
            })];

          case 2:
            _a = _b.sent(), DASH = _a.DASH, DIRECTFILE = _a.DIRECTFILE;
            RxPlayer.addFeatures([DASH, DIRECTFILE]);
            RxPlayer.LogLevel = this.props.debug ? 'DEBUG' : 'NONE';

            this.setLogLevel = function (logLevel) {
              return RxPlayer.LogLevel = logLevel;
            };

            rxPlayer = new RxPlayer({
              videoElement: this.videoElement,
              initialVideoBitrate: INITIAL_BITRATE,
              stopAtEnd: false
            });
            this.controller = new RxPlayerController_1["default"](rxPlayer);

            if (this.props.onControllerChange) {
              this.props.onControllerChange(this.controller);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  RxPlayerBackend.prototype.safeComponentDidUpdate = function (prevProps) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (prevProps.debug !== this.props.debug && this.setLogLevel) {
          this.setLogLevel(this.props.debug ? 'DEBUG' : 'NONE');
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  RxPlayerBackend.prototype.render = function () {
    var _this = this;

    return React.createElement("video", {
      ref: function ref(el) {
        return _this.videoElement = el;
      },
      playsInline: this.props.playsInline,
      className: this.props.className,
      controls: Boolean(this.props.useNativeControls)
    });
  };

  return RxPlayerBackend;
}(components_1.SafeAsyncComponent);

exports.RxPlayerBackend = RxPlayerBackend;
exports["default"] = RxPlayerBackend;